export const makeReport = (
  reportData = [],
  regions = [],
  groups = [],
  categories = [],
  users = [],
  ratesType = []
) => {
  // const groupsObject = groups.reduce(
  //   (a, v) => ({ ...a, [v._id]: v.title }),
  //   {}
  // );
  const parentCategories = categories
    .filter((item) => !item.parent)
    .reduce((a, v) => ({ ...a, [v._id]: v.title }), {});
  // const usersMap = users.reduce(
  //   (a, v) => ({
  //     ...a,
  //     [v._id]: `${v.lastName} ${v.middleName} ${v.firstName}`,
  //   }),
  //   {}
  // );
  // const regionsMap = regions.reduce(
  //   (a, v) => ({
  //     ...a,
  //     [v._id]: v.title,
  //   }),
  //   {}
  // );
  const pCats = categories.filter((item) => !item.parent);

  const getRateType = (rate) => {
    const foo = ratesType.find((item) => {
      return item.startRange <= rate && rate <= item.endRange;
    });

    return foo?.title;
  };
  const report = reportData.map((item, idx) => {
    let parentCats = pCats;
    let categoriesAll = {};
    item?.categorys.forEach((itmn) => {
      parentCats = parentCats.filter((e) => e._id !== itmn.category);
      categoriesAll[itmn.category] = {
        value: itmn?.categoryRate ? Math.round(itmn?.categoryRate) : 0,
        id: itmn.category,
        userId: item._id && item._id.user?._id,
        categoryValue: itmn?.categoryRate ? Math.round(itmn?.categoryRate) : 0,
        categoryTitle: parentCategories[itmn.category],
        groupId: Math.floor(Math.random() * Date.now()),
      };
    });
    // parentCats.forEach((itmn) => {
    //   categoriesAll[itmn._id] = {
    //     value: null,
    //     id: itmn._id,
    //     categoryValue: null,
    //     categoryTitle: parentCategories[itmn._id],
    //     groupId: Math.floor(Math.random() * Date.now()),
    //   };
    // });
    return {
      id: idx + 1,
      ...categoriesAll,
      user_name: {
        name: item._id
          ? `${item._id?.user.firstName} ${item._id?.user.lastName}`
          : '',
        value: Math.min(Math.round(item?.allRate), 100),
      },
      total: {
        value: Math.min(Math.round(item?.allRate), 100),
        userRank: Math.min(Math.round(item?.allRate), 100),
        userRateType: getRateType(Math.min(Math.round(item?.allRate), 100)),
      },
    };
  });
  return report;
};

export const makeReportAllgroups = (
  reportsData = [],
  categories = [],
  groups = []
) => {
  const report = reportsData.map((item) => {
    const category = categories.find((itm) => itm._id === item.category);
    const group = item?.groups.map((value) => {
      const str = groups.find((e) => e._id === value.group);
      return {
        id: Date.now(),
        title: str ? str.title : '',
        percent: checkWorkAndPlan(value.work, value.plan),
      };
    });
    return {
      id: Date.now(),
      mainTitle: category ? category.title : '',
      resultsTitle: 'Гуруҳлар умумий кўрсаткичлари',

      tasks: {
        marked: item.plans,
        completed: item.works,
      },
      percent: checkWorkAndPlan(item.works, item.plans),
      results: group,
    };
  });
  return report;
};

export const makeReportGrops = (card = [], categories = []) => {
  const cardReport = card.map((item) => {
    const category = categories.find((itm) => itm._id === item.category);
    const group = item?.groups
      .map((value) => {
        return {
          id: value?.group?._id,
          title: value?.group?.title ?? '',
          percent: checkWorkAndPlan(value.work, value.plan),
        };
      })
      ?.sort((a, b) => b?.percent - a?.percent)
      ?.slice(-4);

    return {
      id: Date.now(),
      mainTitle: category ? category.title : '',
      resultsTitle: 'Гуруҳлар умумий кўрсаткичлари',
      tasks: {
        marked: item.plans,
        completed: item.works,
      },
      percent: checkWorkAndPlan(item.works, item.plans),
      results: group,
    };
  });
  return cardReport;
};

export const makeReportOnegroup = (reportsData = []) => {
  const report = reportsData.map((item) => {
    return {
      id: Date.now(),
      mainTitle: item?.category.title ? item.category.title : '',
      resultsTitle: 'Гуруҳлар умумий кўрсаткичлари',
      tasks: {
        marked: item.plans,
        completed: item.works,
      },

      percent: checkWorkAndPlan(item.works, item.plans),
      results: '',
    };
  });
  return report;
};
export const checkWorkAndPlan = (work, plan) => {
  if (work === 0 && plan === 0) {
    return 0;
  }
  if (plan === 0 && work > 0) {
    return 100;
  }
  return Math.min(Math.round((Number(work) * 100) / Number(plan)), 100);
};

const checkWorksAndPlans = (data = []) => {
  if (data.length == 0) return 0;
  return (
    data
      .map((item) => checkWorkAndPlan(item.work, item.plan))
      .reduce((total, itm) => total + itm) / data.length
  );
};

export const makeReportBygroup = (reportsData = [], regions = [], category) => {
  
  const data = regions.map((item) => {
    const foo = reportsData[0].regions.filter(
      (itm) => itm?.region?._id === item._id
    );
    if (foo.length === 1) {
      return {
        regionName: item.title,
        percent: checkWorkAndPlan(foo[0].work, foo[0].plan),
      };
    } else {
      return {
        regionName: item.title,
        percent: checkWorksAndPlans(foo),
      };
    }
  });
  return data;
};
